/** Format a moment in Singapore time for prize-wheel receipts. Example: `24 March 2026 (Tue) 10:08PM` */
export function formatSingaporeSpinTimestamp(date: Date): string {
  const f = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Singapore',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  const parts = f.formatToParts(date);
  const m: Record<string, string> = {};
  for (const p of parts) {
    if (p.type !== 'literal') m[p.type] = p.value;
  }
  const ap = (m.dayPeriod ?? '').replace(/\s/g, '').toUpperCase();
  const time = `${m.hour}:${m.minute}${ap}`;
  return `${m.day} ${m.month} ${m.year} (${m.weekday}) ${time}`;
}
